type Props = {
  error: string
  closeLabel: string
  actionLabel?: string
  onAction?: () => void
  onClose: () => void
}

export const CartErrorBanner = ({ error, closeLabel, actionLabel, onAction, onClose }: Props) => {
  if (!error) return null

  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-3 text-sm text-amber-800 shadow-sm">
      <div className="flex items-center justify-between gap-3">
        <span>{error}</span>
        <div className="flex items-center gap-2">
          {actionLabel && onAction ? (
            <button
              type="button"
              onClick={onAction}
              className="rounded-full border border-amber-300 bg-white px-2 py-1 text-xs font-semibold hover:bg-amber-100"
            >
              {actionLabel}
            </button>
          ) : null}
          <button
            type="button"
            onClick={onClose}
            className="rounded-full border border-amber-300 px-2 py-1 text-xs font-semibold hover:bg-amber-100"
          >
            {closeLabel}
          </button>
        </div>
      </div>
    </div>
  )
}
